export const registrationData = {
  indian: {
    mainConference: {
      onsite: {
        "AFPI/ FFPAI Indian delegate": 14000,
        "Non AFPI Indian delegate": 16000,
        "AFPI-PGs": 13000,
        "Non AFPI-PGs": 13000,
        "Undergraduate medical students or other allied medical profession": 6000,
        "Nurses, allied health healthcare administrators": 6000,
        "Accompanying person": 6000
      }
    },
    fullConference: {
      onsite: {
        "AFPI/ FFPAI Indian delegate": 19000,
        "Non AFPI Indian delegate": 22000,
        "AFPI-PGs": 17000,
        "Non AFPI-PGs": 18000,
        "Undergraduate medical students or other allied medical profession": 10000,
        "Nurses, allied health healthcare administrators": 10000,
        "Accompanying person": 8000
      }
    }
  },
  international: {
    mainConference: {
      onsite: {
        "WONCA Direct Member": 500,
        "International delegates (Developing countries and SAARC countries)": 250,
        "International delegates (Other than Developing countries and SAARC Countries)": 600,
        "YDM-SAARC (Young doctors' movement)": 200,
        "Undergraduate medical students or other allied medical profession": 200,
        "Nurses, allied health healthcare administrators": 200,
        "Accompanying person SAARC": 200,
        "Accompanying person Non-SAARC": 300
      }
    },
    fullConference: {
      onsite: {
        "WONCA Direct Member": 750,
        "International delegates (Developing countries and SAARC countries)": 375,
        "International delegates (Other than Developing countries and SAARC Countries)": 900,
        "YDM (Young doctors' movement)": 275,
        "Undergraduate medical students or other allied medical profession": 250,
        "Nurses, allied health healthcare administrators": 250,
        "Accompanying person SAARC": 250,
        "Accompanying person Non-SAARC": 350
      }
    }
  }
};

export const getRegistrationPeriod = () => {
  const today = new Date();
  const earlyBirdEndDate = new Date('2024-12-31');
  const regularEndDate = new Date('2025-03-30');
  
  if (today <= earlyBirdEndDate) {
    return 'earlyBird';
  } else if (today <= regularEndDate) {
    return 'regular';
  } else {
    return 'onsite';
  }
};

export const indianDelegateTypes = [
  "AFPI/ FFPAI Indian delegate",
  "Non AFPI Indian delegate",
  "AFPI-PGs",
  "Non AFPI-PGs",
  "Undergraduate medical students or other allied medical profession",
  "Nurses, allied health healthcare administrators",
  "Accompanying person",
  "Faculty"
];

export const internationalDelegateTypes = [
  "WONCA Direct Member",
  "International delegates (Developing countries and SAARC countries)",
  "International delegates (Other than Developing countries and SAARC Countries)",
  "YDM-SAARC (Young doctors' movement)",
  "YDM (Young doctors' movement)",
  "Undergraduate medical students or other allied medical profession",
  "Nurses, allied health healthcare administrators",
  "Accompanying person SAARC",
  "Accompanying person Non-SAARC",
  "Faculty"
]; 